import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
  CFText,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/3Tuw1rtSEbC81TBepgQL/locations/wIUSq5DS5MCg1FtIjK4Z`}
              style={{ textDecoration: 'none' }}
            >
              <CFView column center w="100%">
                <CFText style={{ fontSize: 16 }} color="#B31E2D" helvitica>
                  order
                </CFText>
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/3Tuw1rtSEbC81TBepgQL/locations/wIUSq5DS5MCg1FtIjK4Z`}
              style={{ textDecoration: 'none' }}
            >
              <CFView column center w="100%">
                <CFText style={{ fontSize: 16 }} color="#B31E2D" helvitica>
                  order
                </CFText>
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
